export default function getNextTodoId(itemId: string, taskIds: string[]): string | null {
    const currentIndex = taskIds.indexOf(itemId);
    if (currentIndex < 0 || currentIndex === taskIds.length - 1) {
        return null;
    }

    return taskIds[currentIndex + 1];
}
